import { defineComponent as r, shallowRef as u, watch as m, computed as f, openBlock as p, createBlock as d, resolveDynamicComponent as y, normalizeStyle as _, normalizeClass as h } from "vue";
import { useIcons as v } from "./icons.esm.js";
import { i as w } from "./helper-BIBe7yYh.js";
const C = /* @__PURE__ */ r({
  __name: "Icon",
  props: {
    name: {},
    size: { default: "20" },
    class: { default: "" }
  },
  setup(c) {
    const t = u(null), e = c, { getIcon: a } = v(), n = async () => {
      const s = a(e.name);
      let o = s;
      if (typeof s == "function" && (o = s()), w(o)) {
        const i = (await o).default;
        t.value = i;
      } else
        t.value = o;
    };
    n(), m(
      () => e.name,
      (s, o) => {
        s && s !== o && n();
      }
    );
    const l = f(() => typeof e.class == "string" ? [e.class, "w-5"] : [e.class, "w-5"].join(" "));
    return (s, o) => (p(), d(y(t.value), {
      style: _({ width: e.size, height: e.size }),
      class: h(l.value)
    }, null, 8, ["style", "class"]));
  }
});
export {
  C as _
};
//# sourceMappingURL=Icon.vue_vue_type_script_setup_true_lang-BMhFqNxf.js.map
